export default __webpack_public_path__ + "static/2040-2-bba6f7aed92fd8009e21a1f31e157713.jpg";